import React from "react";
import { BsFillCaretLeftFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

const BackButton = () => {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate(-1)}
      className="py-1 kxl:py-3 px-2 kxl:px-6 flex items-center justify-center gap-x-1 text-xl font-semibold uppercase rounded bg-custom-blue-600 text-white focus:outline-none focus:ring-4 focus:ring-custom-blue-600"
    >
      <BsFillCaretLeftFill size={25} />
      Back
    </button>
  );
};

export default BackButton;
